import React from "react";

const DateFilter = ({ fromDate, toDate, setFromDate, setToDate }) => {
  return (
    <div className="date-filter ">
      <div className="date-field">
        <label className="date-label">From :</label>
        <input
          type="date"
          className="date-input"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />
      </div>

      <div className="date-field">
        <label className="date-label">To :</label>
        <input
          type="date"
          className="date-input"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />
      </div>
    </div>
  );
};

export default DateFilter;